import React from "react";
import SocialIcons from "./SocialIcons";

function CopyrightSection() {
  return (
    <section className="footer-background">
      <style jsx>{`
        .footer-background {
          background-color: #0c4a6e;
          width: 100vw;
          margin: 0;
          padding-bottom: 1rem;
        }
        @media (max-width: 576px) {
          .copyright-section {
            gap: 1.5rem;
            text-align: center;
          }
          .copyright-text {
            text-align: center;
            width: 100%;
          }
        }
      `}</style>

      <div className="copyright-section d-flex flex-column gap-2 justify-content-center align-items-center w-100">
        <div className="d-flex flex-column justify-content-center align-items-center w-100 p-2">
          {/* Frase de direitos reservados */}
          <p
            className="copyright-text text-white mb-0 text-center"
            style={{ fontSize: "0.75rem" }}
          >
            Nação Saúde. Todos os Direitos Reservados.
          </p>

          {/* E-mail de contato */}
          <a
            href="mailto:relacionamento@nacaosaude.app"
            className="text-white text-center"
            style={{ fontSize: "0.75rem", textDecoration: "underline" }}
          >
            relacionamento@nacaosaude.app
          </a>
        </div>

        {/* Ícones sociais */}
        <SocialIcons />
      </div>
    </section>
  );
}

export default CopyrightSection;